import React from "react";
import { Link, useNavigate } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./NewFooter";

const Error404 = () => {
  const navigate = useNavigate();
  return (
    <>
      <NavBar />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <p>404, page not found</p>
        <Link onClick={() => navigate(-1)}>Go back</Link>
      </div>
      <Footer />
    </>
  );
};

export default Error404;
